import useGetPermissions from 'app/hooks/useGetPermissions'

import {
    AccessRight,
    AccessRightsConfig,
} from 'app/types/accessRights.types'
import getPermission from './getPermission'

import accessRoles from './accessRoles'

const useHasPermissionType = (categories: string[], accessRights: AccessRightsConfig, type: keyof AccessRight = 'read') => {
    const permissionsList = useGetPermissions(accessRoles)

    return getPermission(accessRights, permissionsList, categories, type)
}

export default useHasPermissionType
